var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.0001,
    cy: 30.5,
    rx: 30.0704,
    ry: 30.5,
    fill: "#F23B3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6583 15.7885L33.6652 15.2817H33.1583H29.3945H28.8877L28.8945 15.7885L29.1713 36.1575L29.178 36.6507H29.6713H32.8816H33.3748L33.3815 36.1575L33.6583 15.7885ZM32.7791 44.4392L32.7821 44.4374C33.2289 44.165 33.5871 43.8023 33.8505 43.3536C34.1284 42.8964 34.2672 42.3922 34.2672 41.8518C34.2672 41.0346 33.9687 40.3222 33.3873 39.7409C32.806 39.1595 32.0936 38.861 31.2764 38.861C30.4592 38.861 29.7468 39.1595 29.1655 39.7409C28.5841 40.3222 28.2856 41.0346 28.2856 41.8518C28.2856 42.669 28.5841 43.3814 29.1655 43.9627C29.7468 44.5441 30.4592 44.8426 31.2764 44.8426C31.8215 44.8426 32.3267 44.7106 32.7791 44.4392Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/iconWarning.8bffa743bf9e6db359a5b919f4c7de4a.svg";
export { ForwardRef as ReactComponent };